import { useState } from 'react';

export default function Navigation({ isScrolled }: { isScrolled: boolean }) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
    }`}>
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex items-center">
            <span className={`text-2xl font-bold transition-colors ${
              isScrolled ? 'text-[#1e3a5f]' : 'text-white'
            }`} style={{ fontFamily: 'Playfair Display, serif' }}>
              Claim IT Assist
            </span>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-8">
            <a href="#services" className={`text-sm font-medium transition-colors hover:text-[#FF6B35] ${
              isScrolled ? 'text-gray-700' : 'text-white'
            }`}>Services</a>
            <a href="#claims" className={`text-sm font-medium transition-colors hover:text-[#FF6B35] ${
              isScrolled ? 'text-gray-700' : 'text-white'
            }`}>Claims</a>
            <a href="#process" className={`text-sm font-medium transition-colors hover:text-[#FF6B35] ${
              isScrolled ? 'text-gray-700' : 'text-white'
            }`}>Process</a>
            <a href="#about" className={`text-sm font-medium transition-colors hover:text-[#FF6B35] ${
              isScrolled ? 'text-gray-700' : 'text-white'
            }`}>About</a>
            <a href="#careers" className={`text-sm font-medium transition-colors hover:text-[#FF6B35] ${
              isScrolled ? 'text-gray-700' : 'text-white'
            }`}>Careers</a>
            <a href="#contact" className={`text-sm font-medium transition-colors hover:text-[#FF6B35] ${
              isScrolled ? 'text-gray-700' : 'text-white'
            }`}>Contact</a>
          </div>

          {/* Desktop CTA */}
          <div className="hidden lg:flex items-center space-x-4">
            <a href="tel:9089222919" className={`text-sm font-semibold flex items-center space-x-2 transition-colors ${
              isScrolled ? 'text-[#1e3a5f]' : 'text-white'
            }`}>
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-phone-line text-lg"></i>
              </div>
              <span>(908) 922-2919</span>
            </a>
            <button 
              onClick={scrollToContact}
              className="bg-[#FF6B35] text-white px-6 py-2.5 rounded-lg text-sm font-semibold hover:bg-[#ff5722] transition-colors cursor-pointer whitespace-nowrap"
            >
              Free Review
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`lg:hidden w-10 h-10 flex items-center justify-center transition-colors ${
              isScrolled ? 'text-[#1e3a5f]' : 'text-white'
            }`}
          >
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="lg:hidden bg-white border-t border-gray-200 shadow-lg">
          <div className="px-6 py-4 space-y-4">
            <a href="#services" onClick={() => setIsMobileMenuOpen(false)} className="block text-sm font-medium text-gray-700 hover:text-[#FF6B35] transition-colors">Services</a>
            <a href="#claims" onClick={() => setIsMobileMenuOpen(false)} className="block text-sm font-medium text-gray-700 hover:text-[#FF6B35] transition-colors">Claims</a>
            <a href="#process" onClick={() => setIsMobileMenuOpen(false)} className="block text-sm font-medium text-gray-700 hover:text-[#FF6B35] transition-colors">Process</a>
            <a href="#about" onClick={() => setIsMobileMenuOpen(false)} className="block text-sm font-medium text-gray-700 hover:text-[#FF6B35] transition-colors">About</a>
            <a href="#careers" onClick={() => setIsMobileMenuOpen(false)} className="block text-sm font-medium text-gray-700 hover:text-[#FF6B35] transition-colors">Careers</a>
            <a href="#contact" onClick={() => setIsMobileMenuOpen(false)} className="block text-sm font-medium text-gray-700 hover:text-[#FF6B35] transition-colors">Contact</a>
            <a href="tel:9089222919" className="flex items-center space-x-2 text-sm font-semibold text-[#1e3a5f]">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-phone-line text-lg"></i>
              </div>
              <span>(908) 922-2919</span>
            </a>
            <button 
              onClick={scrollToContact}
              className="w-full bg-[#FF6B35] text-white px-6 py-2.5 rounded-lg text-sm font-semibold hover:bg-[#ff5722] transition-colors cursor-pointer whitespace-nowrap"
            >
              Free Review
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}